import type { Action, ActionBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Action, ActionBase>({
  tableName: "actions",
  viewName: "actions_enriched",
  searchColumns: ["title"],
  computedColumns: ["inspectionTitle", "locationName", "assetName", "assigneeName"],
});

export class ActionService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
